<template>
  <div class="product-sku">
    <h2>{{info.title}}</h2>
    <p class="subtitle">
      {{info.subtitle}}
    </p>
    <div class="product-sku-container">
      <div class="product-sku-intro">
        <template v-if="$route.query.type !== 'calendar'">
          <h3>
            {{$t('products.sizeCm')}}
          </h3>
          <div class="sku-row">
            <!-- eslint-disable -->
            <div class="sku-row__cell" v-for="(item, index) in info.size">
              <button class="btn btn-block"
                      :class="[activeSize === item.name ? 'default-ghost' : 'plant']" @click="setActiveSize(item)">
                {{item.label}}
              </button>
            </div>
          </div>
        </template>
        <div v-for="section in sections" :key="section.key">
          <h3>{{section.title}}</h3>
          <select-group :choices="section.value" v-model="selected[section.key]" />
        </div>
        <template v-if="price">
          <h3>{{$t('products.price')}}</h3>
          <div class="product-sku-price">
            <template v-if="$route.query.type === 'diarybook'">
              {{symbols}}{{price.inner}} {{$t('products.perPage')}}
              <span v-if="price.cover">{{$t('products.basePrice', {symbol: symbols, price: price.cover})}}</span>
            </template>
            <template v-else-if="$route.query.type === 'calendar'">
              {{symbols}}{{price}}{{$t('products.perCopy')}}
            </template>
            <template v-else>
              {{symbols}}{{price.cover}}
              <span>{{$t('products.innerPage', {symbol: symbols, price: price.inner})}}</span>
            </template>
          </div>
          <p v-if="$route.query.type !== 'calendar'">{{$t('products.priceEstimate', {num: info.num, title: info.title, symbol: symbols, total: (price.inner * info.num + price.cover).toFixed(1)})}}</p>
          <p>
            <i class="fa fa-info-circle"></i>
            {{$t('products.priceDisclaimer')}}
          </p>
        </template>
        <p v-else class="has-text-grey">
          {{$t('products.calculating')}}
        </p>
      </div>
    </div>
    <div class="product-sku-action">
      <p>
        {{$t('products.shippingEstimate', {date: expressDate})}}
      </p>
      <button class="btn btn-block primary btn-lg" @click="startDraw">
        {{$t('products.startCreating')}}
        <span class="btn-arrow"><i class="fa fa-arrow-right"></i></span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { find, transform, forEach, isEmpty } from 'lodash'

import SelectGroup from './Selector'

export default {
  name: '',
  components: { SelectGroup },
  props: {
    prices: Object
  },
  data () {
    return {
      showModal: false,
      activeSize: '',
      selected: {}
    }
  },
  computed: {
    expressDate () {
      const lang = this.$store.getters.language
      const m = this.$moment().add(7, 'days')
      if (lang === 'en' || lang === 'jp') {
        return m.locale('en').format('MMM DD')
      }
      return m.locale(lang).format('M月D日')
    },
    symbols () {
      return this.$parent.$parent.symbols
    },
    info () {
      switch (this.$route.query.type) {
        case 'calendar':
          return {
            title: this.$t('products.calendarTitle'),
            subtitle: this.$t('products.calendarSubtitle'),
            cate: 'photobook',
            path: '/create',
            num: 20,
            size: [
              {
                name: 'traditional',
                label: 'B5 (25 × 17)',
                sections: [
                  {
                    key: 'binding',
                    title: this.$t('products.bindingStyle'),
                    value: [
                      { name: '2020-h-traditional', label: this.$t('products.horizontal') },
                      { name: '2020-v-traditional', label: this.$t('products.vertical') }
                    ]
                  }
                ]
              }
            ]
          }
        case 'photobook':
          if (this.$route.query.template === 'album') {
            return {
              title: this.$t('products.albumTitle'),
              subtitle: '',
              cate: 'photobook',
              path: '/create',
              num: 24,
              size: [
                {
                  name: 'album',
                  label: 'B5 (25 × 17)'
                }
              ]
            }
          }
          return {
            title: this.$t('products.photobookTitle'),
            subtitle: '',
            cate: 'photobook',
            path: '/create',
            num: 20,
            size: [
              {
                name: 'magazine',
                label: 'B5 (25 × 17)',
                sections: [
                  {
                    key: 'binding',
                    title: this.$t('products.coverMaterial'),
                    value: [
                      { name: 'fabric', label: this.$t('products.fabric') },
                      { name: 'leather', label: this.$t('products.leather') }
                    ]
                  }
                ]
              }
            ]
          }
        case 'diarybook':
        default:
          return {
            title: this.$t('products.diarybookTitle'),
            subtitle: this.$t('products.diarybookSubtitle'),
            cate: 'diarybook',
            path: '/app/shelf?type=diarybook',
            num: 100,
            size: [
              {
                name: 'a5',
                label: 'A5 (14.8 × 21)',
                sections: [
                  {
                    key: 'typeset',
                    title: this.$t('products.layout'),
                    value: [
                      { name: 'waterfall', label: this.$t('products.waterfall') },
                      { name: 'column', label: this.$t('products.dualColumn') }
                    ]
                  },
                  {
                    key: 'binding',
                    title: this.$t('products.binding'),
                    value: [
                      { name: 'paperback', label: this.$t('products.paperback') },
                      { name: 'hardback', label: this.$t('products.hardcover') }
                    ]
                  }
                ]
              },
              {
                name: 'a4',
                label: 'A4 (21× 28.5)',
                sections: [
                  {
                    key: 'typeset',
                    title: this.$t('products.layout'),
                    value: [
                      { name: 'waterfall', label: this.$t('products.waterfall') },
                      { name: 'child', label: this.$t('products.childLayout') }
                    ]
                  },
                  {
                    key: 'binding',
                    title: this.$t('products.binding'),
                    value: [
                      { name: 'paperback', label: this.$t('products.paperback') },
                      { name: 'hardback', label: this.$t('products.hardcover') }
                    ]
                  }
                ]
              }
            ]
          }
      }
    },
    sections () {
      if (!this.activeSize) {
        return []
      }
      const target = find(this.info.size, { name: this.activeSize })
      return target.sections
    },
    price () {
      if (isEmpty(this.prices)) {
        return null
      }
      if (this.$route.query.type === 'calendar') {
        return this.prices[this.activeSize]
      }
      const activeBinding = this.selected.binding
      const activeSize = this.activeSize || 'a5'
      console.log(this.prices[activeSize])
      if (activeSize === 'album') {
        return this.prices[activeSize].normal
      }
      const prices = this.prices[activeSize]
      return prices[activeBinding]
    }
  },
  created () {
    this.activeSize = this.info.size[0].name
    this.selected = transform(this.info.size[0].sections, (result, value) => {
      const choices = value.value
      result[value.key] = choices[0].name
    }, {})
  },
  methods: {
    ...mapActions(['setLoginShow']),
    setActiveSize (item) {
      this.activeSize = item.name
      const target = find(this.info.size, { name: item.name })
      forEach(this.selected, (value, key) => {
        if (!target.sections.filter(t => t.key === value).length) {
          const choices = find(target.sections, { key })
          this.selected[key] = choices.value[0].name
        }
      })
    },
    startDraw () {
      if (this.$route.query.type === 'diarybook') {
        if (this.$store.state.user.uid) {
          this.$router.push('/app/shelf')
        } else {
          this.setLoginShow(true)
        }
        return
      }
      const binding = this.selected.binding || 'fabric'
      this.$router.push(`/setup?type=${this.activeSize}&binding=${binding}`)
    }
  }
}
</script>

<style lang="scss">

.product-sku {
  padding: 0 1rem;
  h2 {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    margin-bottom: 10px;
  }
  .subtitle {
    font-size: 15px;
    font-weight: 400;
    color: #666;
    margin-bottom: 1rem;
  }
  &-container {
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 0 1rem  1.25rem;
    p {
      color: #666;
      font-size: 13px;
      margin: .5rem 0;
    }
  }
  .selector {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    border: 1px solid #eee;
    border-radius: 4px;
    transition: all .35s;
    padding: 6px 0;
    img {
      width: 30%;
      box-shadow: 0 0 4px 2px rgba(0,0,0,.1);
      border-radius: 4px;
    }
  }
  &-price {
    color: $el-color-primary;
    font-weight: 600;
    font-size: 1.25rem;
    span {
      color: #333;
      font-size: 1rem;
    }
  }
  &-action {
    p {
      margin: .5rem 0;
    }
    .btn.btn-block {
      justify-content: center;
      width: 100%;
      padding: 0.875rem 2rem;
      font-size: 1.0625rem;
      font-weight: 600;
    }
  }
  &-intro {
    h3 {
      font-size: 15px;
      font-weight: 600;
      margin: .5rem 0;
    }
  }
}
</style>
